/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Filters listables count reducer
 */

import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { CLEAR_LISTABLES_COUNT, RECEIVE_LISTABLES_COUNT } from '../constants/index'

import { default as metaReducer } from './listablesCountMetaReducer'

const listablesCountReducer = combineReducers({
  data: handleActions(
    {
      [RECEIVE_LISTABLES_COUNT]: (_, action) => action.payload,
      [CLEAR_LISTABLES_COUNT]: () => null,
    },
    null
  ),
  meta: metaReducer,
})

export default listablesCountReducer
